import { Card } from 'primereact/card'
import { Button } from 'primereact/button'
import PaneContainer from '@/layouts/components/PaneContainer'

interface LeftPaneProps {
  selectedSection: string
  onSectionChange: (section: string) => void
}

const sections = [
  { id: 'basicControls', label: '基本コントロール', icon: 'pi pi-sliders-h' },
  { id: 'formElements', label: 'フォーム要素', icon: 'pi pi-pencil' },
  { id: 'dataProcessing', label: 'データ処理', icon: 'pi pi-cog' },
  { id: 'apiIntegration', label: 'API連携', icon: 'pi pi-server' },
  { id: 'tailwindDemo', label: 'Tailwindデモ', icon: 'pi pi-palette' }
]

function LeftPane({ selectedSection, onSectionChange }: LeftPaneProps) {
  return (
    <PaneContainer>
      <div className="text-center mb-4">
        <h2 className="text-primary text-xl m-0">UIコンポーネント</h2>
        <p className="text-sm text-color-secondary mt-2">カテゴリを選択してください</p>
      </div>

      <div className="flex flex-column gap-2">
        {sections.map((section) => (
          <Button
            key={section.id}
            label={section.label}
            icon={section.icon}
            className={`p-button-text justify-content-start ${selectedSection === section.id ? 'bg-primary-100' : ''}`}
            onClick={() => onSectionChange(section.id)}
          />
        ))}
      </div>
    </PaneContainer>
  )
}

export default LeftPane
